import { render, staticRenderFns } from "./ArchiveDownloadLabel.vue?vue&type=template&id=9f83899e&scoped=true"
import script from "./ArchiveDownloadLabel.vue?vue&type=script&lang=js"
export * from "./ArchiveDownloadLabel.vue?vue&type=script&lang=js"
import style0 from "./ArchiveDownloadLabel.vue?vue&type=style&index=0&id=9f83899e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f83899e",
  null
  
)

export default component.exports